import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import CountUp from "@/components/CountUp";

const ease = [0.16, 1, 0.3, 1];

const KPIS = [
  { value: 72, suffix: "%", label: "MAU Growth Target" },
  { value: 91, suffix: "%", label: "Ticket Conversion" },
  { value: 78, suffix: "%", label: "Partner Retention" },
];

const IRBand = () => (
  <section data-testid="ir-band" className="bg-charcoal-900 py-20 sm:py-24">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 sm:px-8 lg:grid-cols-2">
      <Reveal>
        <Eyebrow dark>Investor Relations</Eyebrow>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          We are raising a seed round to fund MVP development, market launch, and team growth.
        </h2>
        <p className="mt-5 max-w-lg text-base leading-relaxed text-slate-400">
          True Life Entertainment is positioned for Boston dominance and scalable growth. We are
          actively seeking strategic investors to accelerate our launch.
        </p>
        <Link
          to="/investors"
          data-testid="ir-band-cta"
          className="group mt-8 inline-flex items-center gap-2 bg-accent px-7 py-3.5 font-mono text-xs font-semibold uppercase tracking-[0.15em] text-white transition-colors duration-200 hover:bg-accent-dark"
        >
          Visit Investor Relations
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Reveal>

      <div className="grid grid-cols-1 gap-px overflow-hidden border border-white/10 bg-white/10 sm:grid-cols-3">
        {KPIS.map((k, i) => (
          <motion.div
            key={k.label}
            data-testid={`ir-kpi-${i}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: i * 0.08, ease }}
            className="bg-charcoal-900 p-7"
          >
            <div className="font-mono text-3xl font-semibold tracking-tight text-white sm:text-4xl">
              <CountUp to={k.value} suffix={k.suffix} dark testId={`ir-kpi-value-${k.value}`} />
            </div>
            <div className="mt-3 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-violet-400">{k.label}</div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default IRBand;
